let pixelsToTravel = 0;
let isScrolling = false;

function horizontalScroll(element) {
  if (!window._maxFPS) {
    return;
  }

  if (pixelsToTravel !== 0) {
    isScrolling = true;
    const direction = pixelsToTravel > 0 ? 1 : -1;
    const absPixelsToTravel = Math.abs(pixelsToTravel);
    // динамический размер шага скролла в зависимости от того сколько осталось проскроллить
    // магические цифры подобраны экспериментальным путём
    let shift = Math.max(Math.round((absPixelsToTravel / window._maxFPS) * 12), 5) * direction;

    requestAnimationFrame(() => {
      if (Math.abs(shift) > absPixelsToTravel) {
        shift = pixelsToTravel;
        pixelsToTravel = 0;
      } else {
        pixelsToTravel -= shift;
      }

      element.scrollBy(shift, 0);
      horizontalScroll(element);
    });
  } else {
    isScrolling = false;
  }
}

function wheelHandler(event) {
  const target = event.currentTarget;
  const targetWidth = target.offsetWidth;
  const targetScrollWidth = target.scrollWidth;

  if (targetScrollWidth <= targetWidth) {
    return;
  }

  event.preventDefault();

  const currentPos = target.scrollLeft;
  const minPos = -currentPos;
  const maxPos = target.scrollWidth - targetWidth - currentPos;

  let { deltaY } = event;

  if (event.wheelDeltaY === 0 && event.deltaMode === 0) {
    deltaY = event.deltaX;
  }

  pixelsToTravel += deltaY;
  pixelsToTravel = Math.round(Math.min(Math.max(pixelsToTravel, minPos), maxPos));

  const fromForwardToBackward = pixelsToTravel > 0 && deltaY < 0;
  const fromBackwardToForward = pixelsToTravel < 0 && deltaY > 0;

  if (fromForwardToBackward || fromBackwardToForward) {
    pixelsToTravel = deltaY;
  }

  if (pixelsToTravel !== 0 && !isScrolling) {
    horizontalScroll(target);
  }
}

// eslint-disable-next-line import/prefer-default-export
export { wheelHandler };
